var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoManage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_manage",
    d: "M421.565,573.775a5.07,5.07,0,1,0,5.2,5.068A5.143,5.143,0,0,0,421.565,573.775Zm2.8,4.165L421.55,580.9a.883.883,0,0,1-1.249.022l-1.518-1.478a.828.828,0,0,1,0-1.194.883.883,0,0,1,1.227,0l.881.858,2.206-2.314a.873.873,0,0,1,.636-.27.882.882,0,0,1,.591.226A.831.831,0,0,1,424.369,577.94Zm6.2,1.016a9.022,9.022,0,0,1-13.923,7.434l-1.218,1.212a.824.824,0,0,1-.545.237h-.027a.814.814,0,0,1-.813-.788L414,583.813a.809.809,0,0,1,.81-.811h2.173a6.252,6.252,0,0,0,1.737,1.289.851.851,0,0,1-.053.08l-.86.857a7.412,7.412,0,0,0,3.6,1h.129a7.415,7.415,0,0,0,7.4-7.281,7.116,7.116,0,0,0-.316-2.1l-.011-.046a.809.809,0,0,1,1.45-.648l.044-.011.073.239A8.788,8.788,0,0,1,430.565,578.956Zm-1.441-8.315v3.238a.808.808,0,0,1-.807.8h-2.175a6.245,6.245,0,0,0-1.737-1.287.69.69,0,0,1,.057-.084l.864-.851a7.391,7.391,0,0,0-3.609-1.009,7.407,7.407,0,0,0-7.531,7.279,7.064,7.064,0,0,0,.317,2.1l.011.045a.8.8,0,0,1-.556.958.836.836,0,0,1-.23.034.815.815,0,0,1-.776-.571,8.753,8.753,0,0,1-.387-2.567A9.023,9.023,0,0,1,426.5,571.3l1.242-1.221a.809.809,0,0,1,.553-.232h.017A.813.813,0,0,1,429.124,570.641Z",
    transform: "translate(-412.565 -569.839)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoManage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_manage.e6bf8a14e36d7c27b7b897101df702b8.svg";